import { useForm } from 'react-hook-form';
import {
  DeleteWorkScheduleSlotRecurrenceFormValues,
  deleteWorkScheduleSlotRecurrenceFormResolver,
} from './schema';

export type DeleteWorkScheduleSlotRecurrenceUseForm = ReturnType<
  typeof useForm<DeleteWorkScheduleSlotRecurrenceFormValues>
>;

export const useDeleteWorkScheduleSlotRecurrenceForm = (
  defaultValues?: Partial<DeleteWorkScheduleSlotRecurrenceFormValues>,
) => {
  const deleteWorkScheduleSlotRecurrenceForm =
    useForm<DeleteWorkScheduleSlotRecurrenceFormValues>({
      resolver: deleteWorkScheduleSlotRecurrenceFormResolver,
      defaultValues: {
        mode: 'delete-occurrence',
        ...defaultValues,
      },
      // mode: 'all',
    });

  return { deleteWorkScheduleSlotRecurrenceForm };
};
